// Simple i18n helper used by the UI for small text pieces
const translations = {
  en: {
    notifications: 'Notifications',
    loading: 'Loading...',
    markAllRead: 'Mark All Read',
    markAllReadTitle: 'Mark all notifications as read',
    noNotifications: 'No notifications',
    failedToLoad: 'Failed to load notifications',
  },
  ar: {
    notifications: 'الإشعارات',
    loading: 'جاري التحميل...',
    markAllRead: 'تحديد الكل كمقروء',
    markAllReadTitle: 'تحديد كل الإشعارات كمقروءة',
    noNotifications: 'لا توجد إشعارات',
    failedToLoad: 'فشل تحميل الإشعارات',
  }
};

export function tr(key, language = 'en') {
  const lang = language === 'ar' ? 'ar' : 'en';
  return (translations[lang] && translations[lang][key]) || translations['en'][key] || key;
}

export default tr;
